module.exports = __webpack_public_path__ + "6f9e0e238c7a915a8e2c4b79b59d1cd3.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./www/assets/img/asistencia-img.jpg
 ** module id = 442
 ** module chunks = 8
 **/